getTransformedMessage